import React, { useCallback, useState } from "react"
import { centsClient } from "../../../../api/cents/clients/cents-client"
import LoginFormStructure from "../LoginFormStructure"
import LoginInput from "../LoginInput"
import { FilledButton } from "../../common/buttons/FilledButton"
import { CheckCircleIcon } from "@heroicons/react/24/outline"
import { translations } from "../../../../utils/translations/translations-manager"

export function RecoveryPasswordForm({ initialUsername, onConfirm, onError, onCancel }: { initialUsername: string | undefined, onConfirm: (username: string | undefined) => void, onError: (message: 'recover_password_error') => void, onCancel: () => void }): JSX.Element {
  const [username, setUsername] = useState<string | undefined>(initialUsername)
  const [state, setState] = useState<'idle' | 'success'>('idle')
  const [loading, setLoading] = useState<boolean>(false)
  const recoverPassword = useCallback(async () => {
    // TODO: Controllare username e visualizzare errore
    if (!username) {
      return
    }
    setLoading(true)
    try {
      await centsClient.auth.recover(username)
    } catch {
      onError('recover_password_error')
      setLoading(false)
      return
    }
    setLoading(false)
    setState('success')
  }, [username])
  return (
    <>
      {state === 'idle' && <LoginFormStructure
        title={translations.texts.recover_password.toString()}
        handleSubmit={recoverPassword}>
        <>
          <LoginInput name={'username'} value={username} setValue={setUsername} />
          <FilledButton label={"Invia email"} loading={loading} className="min-h-10 w-full" type="submit" />
          <div className="w-full justify-center items-center text-center">
            <p onClick={onCancel} className="truncate cursor-pointer overflow-hidden underline text-blue-700 mt-4">{translations.texts.back_to_login.toString()}</p>
          </div>
        </>
      </LoginFormStructure>}
      {state === 'success' && <>
        <div className="flex flex-col items-center justify-center">
          <CheckCircleIcon className="mr-2 mb-2 w-12 h-12 stroke-emerald-500" />
          <p className="mb-5">
            {translations.texts.check_your_email_for_password_recovery.toString()}
          </p>
        </div>
        <FilledButton label={"Torna al login"} onClick={() => onConfirm(username)} className="min-h-10 w-full" /></>}
    </>
  )
}